/**
 * @description This enum represents the different SUA-statuses available for a RegisterControl.
 * @author Timothy Biörck
 */

export enum SuaStatusType {
  NOT_SENT = 'Ej skickad',
  SENT = 'Skickad',
  APPROVED = 'Godkänd',
  CANCELLED = 'Avslutad',
  REPORT = 'Skall avrapporteras',
  REPORTED = 'Avrapporterad',
  DENIED = "Avslag"
}

export namespace SuaStatusType {

  /**
   * Returns an array of all values that the different types are set to
   * (i.e SuaStatusType.SENT will return the value 'Skickad').
   * @returns {Array<String>} Array of the type's string value.
   */
  export function getValues(): Array<String> {
    return [ 
      SuaStatusType.NOT_SENT,
      SuaStatusType.SENT,
      SuaStatusType.APPROVED,
      SuaStatusType.CANCELLED,
      SuaStatusType.REPORT,
      SuaStatusType.REPORTED,
      SuaStatusType.DENIED
    ]
  }
}
